import { useMemo } from "react";

import { selectProfitCalculator } from "../features/productAnalyzer/productAnalyzer.selector";
import { useAppSelector } from "../store/hooks";
import { ProfitCalculator } from "../helpers";
import { selectExtension } from "../features/extension/extension.selector";
import {
  fetchExtensionExternal,
  fetchExtensionInternal,
  TFetchExtensionParam,
  TFetchExtensionResponse,
} from "../utils/extension";

export const useExtension = () => {
  const { isExtension } = useAppSelector(selectExtension);

  const fetchExtension = (
    arg: TFetchExtensionParam,
  ): Promise<TFetchExtensionResponse | null> => {
    if (isExtension) {
      return fetchExtensionInternal(arg);
    } else {
      return fetchExtensionExternal(arg);
    }
  };

  return { fetchExtension };
};

export default useExtension;
